import { FC, ReactNode } from 'react';

type Props = {
  content: ReactNode;
  id: string;
  title: ReactNode;
};

// eslint-disable-next-line no-unused-vars
const TabItem: FC<Props> = () => <div />;

export default TabItem;
